// Import Vue core modules
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Import UI Framework
import vuetify from './plugins/vuetify'
import VueConfirmDialog from 'vue-confirm-dialog'

// Import libraries modules
import VueSocketIO from 'vue-socket.io'
import api from '@/apis'

// Modules init
Object.defineProperty(Vue.prototype, '$api', { value: api })
Vue.use(VueConfirmDialog)
Vue.use(require('vue-moment'))
Vue.use(
  new VueSocketIO({
    debug: true,
    connection: process.env.VUE_APP_SOCKET_SERVER_ENDPOINT,
    vuex: {
      store,
      actionPrefix: 'socket_',
      mutationPrefix: 'SOCKET_'
    }
  })
)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
